import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import RateEditorPage from '@/pages/RateEditorPage';
import ActuarialSignOffPage from '@/pages/ActuarialSignOffPage';
import CalibrationTimelinePage from '@/pages/CalibrationTimelinePage';
import ScoreBandsPage from '@/pages/ScoreBandsPage';
import AppetiteRulesPage from '@/pages/AppetiteRulesPage';
import ReferralRulesPage from '@/pages/ReferralRulesPage';
import MatrixRatingPage from '@/pages/MatrixRatingPage';

export default function RateTablesModule() {
  const tabs = [
    { id: 'editor', label: 'Rate Editor', content: <RateEditorPage /> },
    { id: 'matrices', label: 'Scheme Matrices', content: <MatrixRatingPage /> },
    { id: 'score-bands', label: 'Score Bands', content: <ScoreBandsPage /> },
    { id: 'appetite', label: 'Appetite', content: <AppetiteRulesPage /> },
    { id: 'referral-rules', label: 'Referral Rules', content: <ReferralRulesPage /> },
    { id: 'signoff', label: 'Actuarial Sign-Off', content: <ActuarialSignOffPage /> },
    { id: 'calibration', label: 'Calibration Timeline', content: <CalibrationTimelinePage /> },
  ];

  return (
    <ModuleShell title="Rate Tables" subtitle="MARAIS no-code rate editor — propose, sign off, version & rollback" tabs={tabs} />
  );
}
